import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DashboardUserHeaderModule } from '@dashboards/components/dashboard-user-header/dashboard-user-header.module';
import { TurnoverConfigurationStepAssigneeComponent } from '@main-application/management/components/turnover-configuration/components/turnover-configuration-step-assignees/turnover-configuration-step-assignees.component';
import { TurnoverConfigurationStepAssigneesCellModule } from '@main-application/management/components/turnover-configuration/components/turnover-configuration-step-assignees-cell/turnover-configuration-step-assignees-cell.module';
import { PortfolioStoreModule } from '@portfolio/store/portfolio-store.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { DashboardContainerModule } from '@ui-components/components/dashboard-container/dashboard-container.module';
import { EditedCellModule } from '@ui-components/components/edited-cell/edited-cell.module';
import { IconModule } from '@ui-components/components/icon/icon.module';
import { SearchInputModule } from '@ui-components/components/search-input/search-input.module';
import { SkeletonLoaderModule } from '@ui-components/components/skeleton-loader/skeleton-loader.module';
import { TableActionButtonsModule } from '@ui-components/components/table-action-buttons/table-action-buttons.module';
import { TableEmptyContentModule } from '@ui-components/components/table-empty-content/table-empty-content.module';
import { UserSelectDropdownModule } from '@ui-components/components/user-select-dropdown/user-select-dropdown.module';
import { UiComponentsModule } from '@ui-components/ui-components.module';

import { TurnoverConfigurationStepAssigneesEffects } from './effects/turnover-configuration-step-assignees.effects';
import * as fromResponsibleParties from './reducers/turnover-configuration-step-assignees.reducer';

@NgModule({
  declarations: [TurnoverConfigurationStepAssigneeComponent],
  imports: [
    CommonModule,
    PortfolioStoreModule,
    EffectsModule.forFeature([TurnoverConfigurationStepAssigneesEffects]),
    StoreModule.forFeature(fromResponsibleParties.reponsiblePartiesFeatureKey, fromResponsibleParties.reducer),
    DashboardContainerModule,
    DashboardUserHeaderModule,
    SearchInputModule,
    ReactiveFormsModule,
    MatTableModule,
    MatSortModule,
    EditedCellModule,
    UserSelectDropdownModule,
    PipesModule,
    TableActionButtonsModule,
    TableEmptyContentModule,
    IconModule,
    MatButtonModule,
    TurnoverConfigurationStepAssigneesCellModule,
    SkeletonLoaderModule,
    UiComponentsModule,
    MatCheckboxModule,
    MatTooltipModule,
  ],
  exports: [TurnoverConfigurationStepAssigneeComponent],
})
export class TurnoverConfigurationStepAssigneesModule {}
